module.exports = __webpack_public_path__ + "static/media/penguin-homecomming.fb2628b9.png";